var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-rich",style:({
    fontSize: _vm.bindState && _vm.fontSize && (/vw|px|%/.test(_vm.fontSize) ? _vm.fontSize : (_vm.fontSize + "px")),
    color: _vm.bindState && _vm.color
  }),domProps:{"innerHTML":_vm._s(_vm.isDef(_vm.bindState) ? _vm.bindState : _vm.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }